import styled from 'styled-components';
import colors from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import Image from '../Image';

export const Heading = styled.h3`
  ${fonts.paragraph}
  margin: 0;
  padding-bottom: ${spacing(1.5)};

  ${mediaQuery.tabletPortrait`
    padding-bottom: ${spacing(1)};
  `}

  ${mediaQuery.tabletLandscape`
    padding-bottom: ${spacing(1.5)};
  `}
`;

export const AuthorName = styled.span`
  font-weight: normal;
  word-break: break-word;
`;

export const AuthorInfoContainer = styled.div`
  margin: ${spacing(3)} 0;
  padding: ${spacing(3)};
  display: flex;
  flex-direction: row;
  background-color: ${colors.neutral07};

  ${mediaQuery.tabletPortrait`
    margin: ${spacing(4)} 0;
  `}

  ${mediaQuery.tabletLandscape`
    padding: ${spacing(4)};
  `}
`;

export const AuthorInfoContent = styled.div`
  padding-left: ${spacing(2)};
`;

export const AuthorImage = styled(Image)`
  width: ${spacing(6)};
  height: ${spacing(6)};
  border-radius: ${spacing(3)};
`;
